import { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { default as SuppliesService } from 'services/Supplies';

const StyledElement = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--plenoil-red);
    color: white;
    font-size: 11px;
    line-height: 100%;
    animation: blinker 1s linear infinite;
    cursor: pointer;

    @keyframes blinker {
        50% {
            opacity: 0;
        }
    }
`;

let axiosCancelToken = null;

export default function SuppliesOrdersTcReviewWarningGlobe() {
    const navigate = useNavigate();

	const [count, setCount] = useState(null);

    useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);

    useEffect(() => {
		let getWarningsCount = async () => {
            let count = await SuppliesService.getBCOrdersTcForReviewCount();
            setCount(count ?? null);
        }
        getWarningsCount();

        let interval = setInterval(() => {
            getWarningsCount();
        }, 10000);

		return function cleanup() {
           	clearInterval(interval);
        }
	}, []);

	return (
        <>
            { count > 0 &&
                <StyledElement onClick={() => navigate('/supplies/bc-orderstc/station')}>
                    {count}
                </StyledElement>
            }
        </>
	);
}